module.exports = __webpack_public_path__ + "static/media/t-and-c.a4370cb2.svg";